import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 22B3AE2E-C625-4325-8FBE-A98AC004CEE6
 * name chevron-left-box-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-left-box-outline.svg
 * tags
 * - Arrow 
 */
export const ChevronLeftBoxOutlineIcon = createSvgIcon(<><path d="M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M15.71,7.41L11.12,12L15.71,16.59L14.29,18L8.29,12L14.29,6L15.71,7.41Z" /></>, 'ChevronLeftBoxOutlineIcon');
export default ChevronLeftBoxOutlineIcon